module.exports = __webpack_public_path__ + "static/media/hair-stylists-we-facilitate.4c914030.jpg";